<nb-card class="kpi-chart-card" [class.wide]="wide" *ngIf="data">
    <nb-card-header class="chart-card-header">
        <span class="primary-header">{{ data.title }}</span>
        <span class="sub-header">{{ data.subtitle }}</span>
    </nb-card-header>

    <nb-card-body>
        <div class="kpi-bar">
            <div [ngClass]="deltaColor" class="kpi-bar-part bg" [ngStyle]="{'height.%': data.deltaPercent}"></div>
            <div
                class="kpi-bar-part color-gradient-category-1 bg"
                [ngStyle]="{'height.%': 100 - data.deltaPercent}"
            ></div>
        </div>

        <nb-icon
            *ngIf="wide"
            icon="long-arrow-down"
            pack="engin"
            status="basic"
            [class.arrow-up]="data.kpiDirection === KpiOptions.Increasing"
        ></nb-icon>

        <div class="kpi-values">
            <div [ngClass]="deltaColor" class="kpi-values-title color">
                Delta: {{ data.kpiDirection === KpiOptions.Decreasing ? "-" : "" }}{{ data.deltaPercent }}%
            </div>
            <div class="kpi-values-subtitle">{{ data.deltaValue }}</div>
            <div class="kpi-values-info" [ngSwitch]="data.kpiDirection === KpiOptions.Increasing">
                <ng-container *ngSwitchCase="true">Initial: {{ data.baseValue }}</ng-container>
                <ng-container *ngSwitchCase="false">Residual: {{ data.residualValue }}</ng-container>
            </div>
        </div>
    </nb-card-body>
</nb-card>
